import React from 'react';
import _ from 'lodash';

import formatPrice from '../../../../screens/shared/util/formatPrice';
import Icon from 'Components/Icon/Icon';

const TotalBlock = ({ values, arrayHelpers, errors, emptyService }) => {
  const getTotalAmount = (arr) =>
    arr.reduce((total, currentValue) => (total += +currentValue.price * +currentValue.qty), 0);
  return (
    <div className="modal__total-block">
      <button
        className="modal__add-request"
        type="button"
        data-testid="add-service"
        disabled={!_.isEmpty(errors) && typeof errors.services !== 'string'}
        onClick={() => arrayHelpers.push(emptyService)}
      >
        <Icon name="icon-plus" />
        Add service
      </button>
      <div>
        <p className="modal__total-amount">Total amount</p>
        <p className="modal__total-currency" data-testid="total-amount">
          {formatPrice(getTotalAmount(values.services).toFixed(2))} USD
        </p>
      </div>
    </div>
  );
};

export default TotalBlock;
